'use client';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';

const CenterSearch = () => {
    const [text, setText] = useState('');
    const route = useRouter();
    const sendToCenters = () => {
        if (text.trim() !== '') {
            route.push(`/centers?name=${text}`);
        } 
    };
    return (
        <div className="flex gap-2 relative items-center cursor-pointer w-full">
            <Input
                onChange={(e) => setText(e.target.value)}
                value={text}
                type="text"
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        route.push(`/centers?name=${text}`);
                    }
                }}
                id="search-input"
                autoComplete="off"
                placeholder={'نام مرکز درمانی ...'}
                className={`border !bg-white text-black border-neutral-200 outline-none !ring-0 placeholder:!text-[#999999] !rounded-2xl !px-3 py-2.5`}
            />
            <Button
                variant="outline"
                className={` flex !h-[36.8px] !border-0 !px-2.5 absolute left-[3px] hover:!opacity-80 !transition-opacity top-[0.5] w-max !bg-white justify-between text-xs flex-grow`}
            >
                <FaSearch
                    onClick={sendToCenters}
                    className="text-xl text-blue"
                />
            </Button>
        </div>
    );
};

export default CenterSearch;
